import React from 'react';
import Tabs from 'chameleon/ui-stack/ui/base/tabs';
import PropTypes from 'prop-types';
import { get, omit } from 'lodash';

const HorizontalTabs = React.forwardRef(
  ({ tabs, classNames, ...props }, ref) => (
    <Tabs
      classNames={{
        tabActive: `border-b-2 border-blue-500 ${get(
          classNames,
          'mergeTabActive',
          '',
        )}`,
        tabInactive: `border-b-0 ${get(classNames, 'mergeTabInactive', '')}`,
        titleActive: `text-blue-700 ${get(classNames, 'mergeTitleActive', '')}`,
        tab: `px-5 py-8 ${get(classNames, 'mergeTab', '')}`,
        title: `text-gray-700 ${get(classNames, 'mergeTitle', '')}`,
        ...classNames,
      }}
      tabs={tabs}
      {...omit(props, 'classNames')}
      ref={ref}
    />
  ),
);

HorizontalTabs.propTypes = {
  tabs: PropTypes.array,
  initActive: PropTypes.number,
  ...Tabs.propTypes,
};

HorizontalTabs.defaultProps = {
  tabs: [],
  initActive: 0,
  ...Tabs.defaultProps,
};

export default HorizontalTabs;
